module.exports = __webpack_public_path__ + "static/media/bruce3.bd7f2547.mp3";